import React, { useState, useEffect, useRef } from "react";
import { Checkbox } from '@progress/kendo-react-inputs';
import { Dialog } from "@progress/kendo-react-dialogs";
import { Loader } from "@progress/kendo-react-indicators";

const SelectSerialQuntity = ({ callBack, data, isFreeQuantity, businessSetting, companyId, itemRows }) => {
    
    let [serialData, setSerialData] = useState([]);
    let [newSerialData, setNewSerialData] = useState([]);
    let [isLoading, setIsLoading] = useState(false);
    let [serialNo, setSerialNo] = useState('');

    useEffect(() => {
        let itemSerialNo = data.itemSerialNo;
        
        setSerialData(itemSerialNo);
        if (itemSerialNo.length == 0) {
            let serialData = {
                serial_id: new Date().getTime() * -1,
                serial_no: '',
                serialNoAdditionalValue1: '',
                serialNoAdditionalValue2: '',
                isFreeQuantity: isFreeQuantity,
                isSelected: true,
                isNewItem: true
            };
            setNewSerialData([...newSerialData, serialData]);
        }

    }, []);


    const onChangeSerialNo = (value, index) => {
        let updatedData = [...newSerialData];
        updatedData[index].serial_no = value;
        setNewSerialData(updatedData);
        setSerialNo(value);
    }
    const onChangeSerialNoNoAdditional1 = (value, index) => {
        let updatedData = [...newSerialData];
        updatedData[index].serialNoAdditionalValue1 = value;
        setNewSerialData(updatedData);
    }
    const onChangeSerialNoNoAdditional2 = (value, index) => {
        let updatedData = [...newSerialData];
        updatedData[index].serialNoAdditionalValue2 = value;
        setNewSerialData(updatedData);
    }
    const onCheckedChangeNew = (value, index) => {
        let updatedData = [...newSerialData];
        updatedData[index].isSelected = !updatedData[index].isSelected;
        setNewSerialData(updatedData);
    }
    const onCheckedChange = (value, index) => {
        let updatedData = [...serialData];
        updatedData[index].isSelected = !updatedData[index].isSelected;
        setSerialData(updatedData);
    }
    const addMoreSerialData = async () => {
        const hasEmptyValues = newSerialData.some(obj => 
            (businessSetting.SerialNoChk == 1 && !obj.serial_no) || 
            (businessSetting.SerialNoAdditionalChk1 == 1 && !obj.serialNoAdditionalValue1) || 
            (businessSetting.SerialNoAdditionalChk2 == 1 && !obj.serialNoAdditionalValue2)
        );
        if (hasEmptyValues) {
            alert('Some values have empty of new added serial.');
            return;
        } 
        

        let newSerial = {
            serial_id: new Date().getTime() * -1,
            serial_no: '',
            serialNoAdditionalValue1: '',
            serialNoAdditionalValue2: '',
            isFreeQuantity: isFreeQuantity,
            isSelected: true,
            isNewItem: true
        };
        setNewSerialData([...newSerialData, newSerial]);
    }
    const deleteSerialData = (index) => {
        let serialData = newSerialData.filter((data, i) => i !== index);
        setNewSerialData(serialData);
    }
    const saveSerialData = async () => {
        const hasEmptyValues = newSerialData.some(obj => 
            (obj.isSelected && ((businessSetting.SerialNoChk == 1 && !obj.serial_no) || 
            (businessSetting.SerialNoAdditionalChk1 == 1 && !obj.serialNoAdditionalValue1) || 
            (businessSetting.SerialNoAdditionalChk2 == 1 && !obj.serialNoAdditionalValue2)))
        );
        if (hasEmptyValues) {
            alert('Some values have empty of new added serial.');
            return;
        } 
        let _serialData = [...serialData, ...newSerialData];
        const allSerialNo = _serialData.filter((data) => data.serial_no).map((data) => data.serial_no);
        
        const counts = allSerialNo.reduce((acc, num) => {
            acc[num] = (acc[num] || 0) + 1;
            return acc;
          }, {});
        const duplicatesData = Object.keys(counts).filter(num => counts[num] > 1);
        if (duplicatesData.length > 0) {
            alert("The serial numbers ("+duplicatesData+") already exist in the system. Please try another serial number.");
            return;
        }
        const itemRowsSerialNo = itemRows.map((data) => data.selectedData).map((data) => data.filter((data) => data.serial_no).map((data) => data.serial_no));
        const duplicateItemRowsSerialNo = itemRowsSerialNo.flat().filter(item => item !== "");
        const isExitsSerialNos = duplicateItemRowsSerialNo.some(item => allSerialNo.includes(item));
        const meargeSerialNo = [...allSerialNo, ...duplicateItemRowsSerialNo];
        const uniqueSerialNos = [...new Set(meargeSerialNo)];
        if (isExitsSerialNos) {
            alert("The serial numbers ("+uniqueSerialNos+") already exist in the system. Please try another serial number.");
            return;
        }
        const allNewSerialNo = _serialData.filter((data) => data.serial_no && data.serial_id < 1).map((data) => data.serial_no);
        let duplicates = {success: false};
        if(allNewSerialNo.length > 0){
            setIsLoading(true);
            const response = await fetch(global.checkSerialNo, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    allSerialNo: allNewSerialNo,
                    company_id: companyId,
                }),
            });
            duplicates = await response.json();
            setIsLoading(false);
        }
        
        if (_serialData.filter((element) => element.isSelected).length == 0) {
            alert('Please select at least one serial number.');
        } else if (duplicates.success) {
            alert(duplicates.message);
        } else {
            let selectedData = _serialData.filter((element) => element.isSelected);
            let remaingSerialData = _serialData.filter((element) => !element.isSelected);
            let updatedData = {};
            if (isFreeQuantity) {
                selectedData = selectedData.map((data) => ({
                    ...data,
                    isFreeQuantity: isFreeQuantity
                }))
                let _selectedData = data.selectedData.concat(selectedData);
                let selectedFreeData = _selectedData.filter((element) => element.isFreeQuantity);
                updatedData = {
                    ...data,
                    itemSerialNo: remaingSerialData,
                    selectedData: _selectedData,
                    free_quantity: selectedFreeData.length,
                    trackingType: 'Serial',
                    isNewQty: _selectedData.isNewItem ? 'NEW' : 'OLD'
                }
            } else {
                updatedData = {
                    ...data,
                    itemSerialNo: remaingSerialData,
                    selectedData: selectedData,
                    quantity: selectedData.length,
                    trackingType: 'Serial',
                    isNewQty: selectedData.isNewItem ? 'NEW' : 'OLD'
                }
                
            }
            console.log('updatedData', JSON.stringify(updatedData));
            callBack(updatedData, isFreeQuantity);
            
        }
    }
    let clearBottomBorder = { border: "none", outline: "none", background: "transparent" };
    return (
        <div className="webForm px-30"  style={{maxHeight: 600, overflowY: 'auto', marginBottom: 20}}>
            <div style={{marginBottom: 20}}>
                    {
                        serialData.map((element, index) => {
                            return (
                                <div className="form-material row" key={index} style={{border: '2px solid #ccc', marginBottom: 5, paddingTop: 0, padding: 15}}>
                                    {businessSetting.SerialNoChk == 1 &&
                                        <div className="col-3">
                                            <div className="form-material open">
                                                <input
                                                    type="text"
                                                    style={clearBottomBorder}
                                                    value={element.serial_no}
                                                    placeholder={businessSetting.SerialNoTxt}
                                                    readOnly
                                                />
                                                <label htmlFor="login-username">{businessSetting.SerialNoTxt} </label>
                                            </div>
                                        </div>
                                    }
                                    {businessSetting.SerialNoAdditionalChk1 == 1 &&
                                        <div className="col-3">
                                            <div className="form-material open">
                                                <input
                                                    type="text"
                                                    style={clearBottomBorder}
                                                    value={element.serialNoAdditionalValue1}
                                                    placeholder={businessSetting.SerialNoAdditionalLabel1}
                                                    readOnly
                                                />
                                                <label htmlFor="login-username">{businessSetting.SerialNoAdditionalLabel1}</label>

                                            </div>
                                        </div>
                                    }
                                    {businessSetting.SerialNoAdditionalChk2 == 1 &&
                                        <div className="col-3">
                                            <div className="form-material open">
                                                <input
                                                    type="text"
                                                    style={clearBottomBorder}
                                                    value={element.serialNoAdditionalValue2}
                                                    placeholder={businessSetting.SerialNoAdditionalLabel2}
                                                    readOnly
                                                />
                                                <label htmlFor="login-username">{businessSetting.SerialNoAdditionalLabel2}</label>
                                            </div>
                                        </div>


                                    }
                                    <div className="col-3" style={{textAlign: 'right'}}>
                                        <div className="form-material open">
                                            <Checkbox
                                                label={'Select'}
                                                checked={element.isSelected}
                                                onChange={e => onCheckedChange(e.target.value, index)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    } 
                    {
                        newSerialData.length > 0 && 
                        <div>
                            <div
                                style={{
                                width: '100%',        // Full width of its parent
                                height: '1px',        // Line thickness
                                backgroundColor: '#e2e2e2', // Line color (black in this case)
                                margin: '20px 0',      // Optional: Add some margin around the line
                                }}
                            ></div>
                            <div style={{marginTop: 10, marginBottom: -30}}>
                                <h5> New Serial </h5>
                            </div>
                        </div>
                    }
                    {
                        newSerialData.length > 0 && newSerialData.map((element, index) => {
                            return (
                                <div className="form-material row" key={index}>
                                    {businessSetting.SerialNoChk == 1 &&
                                        <div className="col-3">
                                            <div className="form-material open">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={element.serial_no}
                                                    placeholder={businessSetting.SerialNoTxt}
                                                    onChange={e => onChangeSerialNo(e.target.value, index)}
                                                />
                                                <label htmlFor="login-username">{businessSetting.SerialNoTxt} </label>
                                            </div>
                                        </div>
                                    }
                                    {businessSetting.SerialNoAdditionalChk1 == 1 &&
                                        <div className="col-3">
                                            <div className="form-material open">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={element.serialNoAdditionalValue1}
                                                    placeholder={businessSetting.SerialNoAdditionalLabel1}
                                                    onChange={e => onChangeSerialNoNoAdditional1(e.target.value, index)}
                                                />
                                                <label htmlFor="login-username">{businessSetting.SerialNoAdditionalLabel1}</label>

                                            </div>
                                        </div>
                                    }
                                    {businessSetting.SerialNoAdditionalChk2 == 1 &&
                                        <div className="col-3">
                                            <div className="form-material open">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={element.serialNoAdditionalValue2}
                                                    placeholder={businessSetting.SerialNoAdditionalLabel2}
                                                    onChange={e => onChangeSerialNoNoAdditional2(e.target.value, index)}
                                                />
                                                <label htmlFor="login-username">{businessSetting.SerialNoAdditionalLabel2}</label>
                                            </div>
                                        </div>


                                    }
                                    <div className="col-3">
                                        <div className="form-material open">
                                            <Checkbox
                                                label={'Select'}
                                                checked={element.isSelected}
                                                onChange={e => onCheckedChangeNew(e.target.value, index)}
                                            />
                                        </div>
                                    </div>
                                    {
                                        newSerialData.length > 1 &&
                                        <div className="col-3">
                                        <div className="form-material open">
                                        <button
                                            type="button"
                                            className="btn btn-alt-primary"
                                            onClick={() => deleteSerialData(index)} >
                                            <i className="fa fa-check mr-5"></i>
                                            Delete
                                        </button>
                                        </div>
                                    </div>
                                    }
                                </div>
                            )
                        })
                    }
 
                </div>
            <button
                type="button"
                className="btn btn-alt-primary"
                onClick={() => saveSerialData()} >
                <i className="fa fa-check mr-5"></i>
                Save
            </button> 
            <button
                    type="button"
                    style={{marginLeft: 20}}
                    className="btn btn-alt-primary"
                    onClick={() => addMoreSerialData()} >
                    <i className="fa fa-check mr-5"></i>
                    Add more
            </button>
            {
                isLoading && (
                    <Dialog >
                        <div style={{textAlign: 'center'}}>
                            <div style={{marginBottom: '20px'}}><Loader type="infinite-spinner"  /></div>
                            <span>Checking the serial number in the system, please wait...</span>
                        </div>
                    </Dialog>
                )
            }
        </div>
    )
}
export default SelectSerialQuntity